import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import ItemsSlideBlock from '../itemsSlideBlock/itemsSlideBlock'
import Button from '../../button'
import SearchLink from '../../../containers/searchLinkContainer'
import { getWindow } from '../../../../common/utils/window'

import * as styles from './qualityItemsBlock.module.css'

interface ISearchCta {
  title: string
  urlSearchParams: {
    [key: string]: string
  }
}

interface IProps {
  title: string
  subtitle?: string
  data: IItem[]
  cta: ISearchCta
}

const reportClick = (eventLabel: string, eventValue?: number) => {
  reportBlockClick('Quality Items', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const QualityItemsBlock = ({ data, title, subtitle, cta }: IProps) => {
  return (
    <ItemsSlideBlock
      title={title}
      subtitle={subtitle}
      data={data}
      onItemClick={(item, index) => reportClick(`${item.id}`, index)}
    >
      <footer className={styles.footer}>
        <Button
          type={Button.Type.Primary}
          large
          renderAs={SearchLink}
          locationParams={cta.urlSearchParams}
          className={styles.button}
          onClick={() => {
            reportClick(cta.title)
            getWindow().scrollTo(0, 0)
          }}
        >
          {cta.title}
        </Button>
      </footer>
    </ItemsSlideBlock>
  )
}

export default QualityItemsBlock
